module.exports = __webpack_public_path__ + "img/maximum-box.1f532dad.png";